import { createSelector } from '@reduxjs/toolkit';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { FilterableField } from 'components/organisms/tasks/fields';
import { RootState } from 'data';
import { useProjectCustomFields } from 'utils/project-fields/use-project-fields';
import { DynamicTemplateConditions } from '../types';
import { getDynamicConditionFields } from '../utils';
import { useActiveTemplateId } from './use-active-project-template';

const getProjectDynamicTemplateConditions = () =>
  createSelector(
    (state: RootState) => state.templates.project.data,
    (_, { templateId }) => ({
      templateId,
    }),
    (data, { templateId }): DynamicTemplateConditions =>
      data[templateId].dynamicConditions,
  );

export const useProjectDynamicTemplateConditions =
  (): DynamicTemplateConditions => {
    const templateId = useActiveTemplateId();
    const projectDynamicConditions = useMemo(
      getProjectDynamicTemplateConditions,
      [],
    );

    return useSelector((state: RootState) =>
      projectDynamicConditions(state, { templateId }),
    );
  };

export const useDynamicConditionFields = (): FilterableField[] => {
  const { data: projectCustomFields } = useProjectCustomFields();

  return useMemo(
    () => getDynamicConditionFields(projectCustomFields),
    [projectCustomFields],
  );
};
